import { useEffect, useMemo, useRef, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "~/db/db";

const useFilial = ({ formikRef, filiaisDisponiveis, camposOpt = ['codigo', 'nome'], salvarLocalStorage, chave }) => {
  const filialSelect = useSelect("filial");
  const [labelFilial, setLabelFilial] = useState();
  const [filial, setFilial] = useState(0);
  const [fila, setFila] = useState(null);
  const [onFilial, setOnFilial] = useState(false)
  const [filiais, setFiliais] = useState([]);

  useEffect(() => {
    const fetchFiliais = async (signal) => {
      let query = db.filiais;
      let result = [];

      if (filiaisDisponiveis?.length > 0) {
        query = query.where('id').anyOf(filiaisDisponiveis);

        query = query.filter((a) => a.ativo);
        await query.each((item) => result.push(item));

        if (!signal.aborted) {
          setFiliais(result);
        }
      }
    };

    const controller = new AbortController();
    const { signal } = controller;

    fetchFiliais(signal);

    return () => {
      controller.abort();
    };
  }, [filiaisDisponiveis]);

  const optionFiliais = useMemo(() => prepareForOptions((filiais || []).sort((a, b) => a.nome?.localeCompare(b.nome)), camposOpt, 'id'), [filiais]);

  useEffect(() => {
    if (fila && optionFiliais?.length > 0) {
      SetSelectFilial(fila);
    }
  }, [fila, optionFiliais])

  function onChangeFilial(e) {

    setOnFilial(e.value > 0)
    setLabelFilial(e)
    filialSelect.upDateValue(e.value);
    filialSelect.upDateDefaultValue(e || "");

    if (e && e.value && salvarLocalStorage) {
      localStorage.setItem(chave, JSON.stringify(e));
    }

    if (formikRef?.current && formikRef.current.setFieldTouched && formikRef.current.setFieldValue && typeof formikRef.current.setFieldTouched == "function" && typeof formikRef.current.setFieldValue == "function") {
      formikRef?.current?.setFieldValue("filialId", e.value);
      setTimeout(() => formikRef?.current?.setFieldTouched("filialId", true));
    }
    setFilial(e.value);
  }

  function SetSelectFilial(id) {
    if (optionFiliais?.length > 0) {
      const filial = optionFiliais.find((filial) => filial.value === id);
      if (filial)
        onChangeFilial(filial);
      setFila(null);
    } else {
      setFila(id);
    }
  }


  useEffect(() => {
    if(salvarLocalStorage){
      const filialSalva = localStorage.getItem(chave);

    if (filialSalva) {
      const filialObj = JSON.parse(filialSalva);


      SetSelectFilial(filialObj.value);
      onChangeFilial(filialObj);
      setFilial(filialObj.value);
    }
    }
  }, [])

  function CleanForFilterFilial(option) {
    onChangeFilial(option);
    if (!option || !option.value) {
      localStorage.removeItem(chave);
    }
  }

  return {
    filiais,
    optionFiliais,
    labelFilial,
    onChangeFilial,
    SetSelectFilial,
    filial,
    filialSelect,
    setFilial,
    onFilial,
    CleanForFilterFilial
  };
}

export default useFilial;